import filesPageActionTypes from './actionTypes';

function listPush(values: any) {
  return {
    type: filesPageActionTypes.FILES_PAGE_LIST_PUSH,
    values,
  };
}

function listReplace(values: any) {
  return {
    type: filesPageActionTypes.FILES_PAGE_LIST_REPLACE,
    values,
  };
}

function deleteFromFileList(fileId: any) {
  return {
    type: filesPageActionTypes.FILES_PAGE_REMOVE_FILE_FROM_LIST,
    fileId,
  };
}

function listReset() {
  return {
    type: filesPageActionTypes.FILES_PAGE_LIST_RESET,
  };
}

function setSearch(search: any) {
  return {
    type: filesPageActionTypes.FILES_PAGE_SET_SEARCH,
    search,
  };
}

function addDownloadUrlToFile(fileId: any, downloadUrl: any) {
  return {
    type: filesPageActionTypes.FILES_PAGE_ADD_DOWNLOAD_URL_FOR_FILE,
    fileId,
    downloadUrl,
  };
}

function changeFileInList(file: any) {
  return {
    type: filesPageActionTypes.CHANGE_FILE_IN_LIST,
    file,
  };
}

function addFileToList(file: any) {
  return {
    type: filesPageActionTypes.ADD_FILE_TO_LIST,
    file,
  };
}

export default {
  listReset,
  listReplace,
  listPush,
  setSearch,
  deleteFromFileList,
  addDownloadUrlToFile,
  changeFileInList,
  addFileToList,
};
